import React from 'react'
import Header from '../../Component/Header/Header'
import SectionOne from '../../Component/IndexSectionOne/sectionOne.jsx'
import SectionThree from '../../Component/IndexSectionThree/sectionThree.jsx'
import Footer from '../../Component/Footer/Footer'
import styles from './landingPage.module.css';



const LandingPage = () => {
    return (
        <div className={styles.main}>
            <Header/>
            <SectionOne/>
            <SectionThree/>
            <Footer/>
        </div>
    )
}

export default LandingPage
